<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Research and Publication Center for Humanities and Social Sciences (RPCHSS)</h3></header>
              <img src="assets/img/research_centre.jpg">
            <hr>
            <p>
              Research and Publication Center for Humanities and Social Sciences (RPCHSS) is established in the Faculty
              of Humanities and Social Sciences, University of Ruhuna to facilitate and promote research work related to
              the academic disciplines of humanities and social sciences in a more systematic and productive manner
              while increasing research publications
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To develop a research culture in the university by stimulating research in Humanities and Social Sciences among academics, academic supportive staff, undergraduate students, postgraduate students and collaborative researchers
              </li>
              <li>To train academics, undergraduate students, postgraduate students and researchers in the fields of research methods, academic writing, process of publication/ copy rights/ patents, etc.</li>
              <li>To network with other local and international research institutions, exploring opportunities to conduct collaborative research and to share knowledge, experiences and expertise</li>
              <li>To maintain a Data and Information Bank in order to facilitate researchers
              </li>
              <li>To disseminate research findings, organizing national and international conferences, seminars and workshops</li>
              <li>To provide/ arrange consultancy for researchers in obtaining research grants/ travel grants for conference presentations/ publications</li>
              <li>To provide guidance to obtain license/ permissions/ patents/ copy rights through the Technical Transfer Office (TTO) of the university</li>
              <li>To undertake printing, publication work and outsourced funded/ paid research projects for generating income for self-sustainability of the Center</li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Management Committee</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>The Dean of the Faculty, the  ex-officio Chairperson</b>
                    <figure class="professor-description">Mr. Priyantha Renuka
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Coordinator</b>
                    <figure class="professor-description">Dr. Chandika Gunasinghe</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Members</b>
                    <figure class="professor-description">
                      Dr. Shammika Liyanage<br><br>
                      Dr. Suranjith Gunasekara<br><br>
                      Dr. Anushika Kariyawasam<br><br>
                      Dr. Mihra Bandara<br><br>
                      Dr. Upeksha Gamage<br><br>
                      Miss Anuradha Gamage<br><br>
                      Mr. Anuda Kanchana<br><br>
                      Mr Upula Sanjeewa<br><br>
                      Mr. R.M Wijyawaradana<br><br>
                      Miss Ayesha Asra<br><br>
                      Dr. Neel Withanage
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
